import { render, staticRenderFns } from "./OnboardingDialog.vue?vue&type=template&id=4257e5b8&"
import script from "./OnboardingDialog.vue?vue&type=script&lang=ts&"
export * from "./OnboardingDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection})
